<template>
  <div class="col-lg-12 control-section">
    <div class="tree-control-wrapper">
      <ejs-treeview
        id="seatTree"
        ref="seatTree"
        :fields="fields"
        :showCheckBox="true"
        :nodeChecked="nodeChecked"
      ></ejs-treeview>
    </div>
  </div>
</template>

<script>
import commonUtil from './commonUtil';


class TreeDatas {
  constructor(dataSource) {
    this.dataSource = !!dataSource ? dataSource : [{ children: [] }];
    this.id = 'id';
    this.text = 'text';
    this.child = 'children';
    this.expanded = 'state';
  }
}

export default {
  name: 'wrapper',
  data() {
    return {
      fields: new TreeDatas(),
      selectedNode: []
    };
  },
  mounted() {},
  methods: {
    getSeatTree: function (params) {
      params.systemId = 1;
      const _this = this;
      this.$axios
        .get(`/lte/pm/tree/currenttime/seatTree.html${commonUtil.analyticParameter(params)}`, {})
        .then(response => {
          _this.fields = new TreeDatas(response.data);
        });
    },
    // 获取选中节点参数
    getSeleceSeatTreeInfo() {
      return this.selectedNode;
    },
    nodeChecked: function(args) {
      
      //临时存储上一次的结果
      let temporaryStorage={};
      for(let i = 0;i <  this.selectedNode.length ; i++){
        temporaryStorage[this.selectedNode[i]['id']]=this.selectedNode[i]['id'];
      }

      //针对本次变化处理
      for(let i = 0 ;  i < args.data.length;i++){
        if(args.action==="check"){
          if(temporaryStorage[args.data[i].id]){
            //如果上次就已经选中了，本次就不能重复填加了
          }else{
            temporaryStorage[args.data[i].id]=args.data[i].id;
          }
          
        }else{
          delete temporaryStorage[args.data[i].id];
        }
      }
      const checkedNodes = [];
      for(let item in temporaryStorage){
        checkedNodes.push(item);
      }
      let seat = [];
      //过滤掉非叶子节点
      for (let index = 0; index < checkedNodes.length; index++) {
        const measureObj = this.$refs.seatTree.getTreeData(
          checkedNodes[index]
        )[0];

        if (measureObj.children.length === 0) {
          seat.push(measureObj);
        }
      }
      this.selectedNode = seat;
      
      console.log("this.selectedNode:",this.selectedNode);
    }
  }
};
</script>

<style>
</style>
